const contextElements = [{
    type: 'text',
    label: 'Text'
}, {
    type: 'image',
    label: 'Image',
}, {
    type: 'button',
    label: 'Button'
}, {
    type: 'shape',
    label: 'Shapes'
}, {
    type: 'pagination',
    label: 'Pagination'
},
{
    type: 'company-logo',
    label: 'Company Logo'
},
// {
//     type: 'table',
//     label: 'Table'
// }, {
//     type: 'testimonial',
//     label: 'Testimonial'
// }, {
//     type: 'toc',
//     label: 'Table of Contents'
// }, {
//     type: 'header',
//     label: 'Header'
// }, {
//     type: 'footer',
//     label: 'Footer'
// },{
//     type: 'heading',
//     label: 'Heading'
// }
];

const elements = [
    {
    id: null,
    pageId: null,
    name: null,
    selected: false,
    type: 'text',
    body: 'Add some text',
    initialized: false,
    defaultBodyStyles: {
        color: {
            branding: null,
            enabled: true,
            type: null,
            value: '#877D88'
        },
        fontFamily: null,
        fontSize: null,
        lineHeight: null
    },
    isColorPickerOpen: false,
    rotate: 0,
    position: {
        x: 0,
        y: 0,
        z: 1,
    },
    boundingBox: {
        width: 0,
        height: 0,
        top: 0,
        left: 0
    },
    dimensions: {
        width: null,
        height: null
    },
    defaultDimensions: { 
        width: 600,
        height: 240
    },
    innerDimensions: {
        width: null,
        height: null
    },
    rotateCoordinates: {
        x: 0,
        y: 0
    },
    offset: {
        x: 0,
        y: 0
    },
    flip: {
        x: 1,
        y: 1
    },
    degreesDisplayCoordinates: {
        x: -1000,
        y: -1000
    },
    isFocused: false,
    editMode: false,
    dragTolerance: 5,
    isClicked: false,
    isDragging: false,
    isScaling: false,
    isRotating: false,
    isStretching: false,
    isTextClipped: false,
    keepAspectRatio: true,
    mouseX: null,
    mouseY: null,
    startingAngle: 0,
    scaleDirection: null,
    scaleOrigin: 'TOPLEFT',
    borderTolerance: 20,
    opacity: 1,
    visible: true,
    cropable: false,
    subtype: null
}, {
    id: null,
    pageId: null,
    selected: false,
    type: 'image',
    name: null,
    src: null,
    imagePreview: null,
    rotate: 0,
    link: {
        collateralId: null,
        src: null,
        preview: null,
        name: null,
        type: null,
    },
    position: {
        x: 0,
        y: 0,
        z: 1,
    },
    boundingBox: {
        width: 0,
        height: 0,
        top: 0,
        left: 0
    },
    dimensions: {
        width: null,
        height: null
    },
    innerDimensions: {
        width: null,
        height: null
    },
    rotateCoordinates: {
        x: 0,
        y: 0
    },
    offset: {
        x: 0,
        y: 0
    },
    flip: {
        x: 1,
        y: 1
    },
    degreesDisplayCoordinates: {
        x: -1000,
        y: -1000
    },
    dragTolerance: 5,
    isClicked: false,
    isDragging: false,
    isScaling: false,
    isRotating: false,
    isStretching: false,
    keepAspectRatio: true,
    mouseX: null,
    mouseY: null,
    startingAngle: 0,
    scaleDirection: null,
    scaleOrigin: 'TOPLEFT',
    cropType: null,
    opacity: 1,
    visible: true,
    cropable: true,
    subtype: null
}, {
    id: null,
    pageId: null,
    selected: false,
    type: 'shape',
    name: null,
    src: null,
    rotate: 0,
    link: {
        collateralId: null,
        src: null,
        preview: null,
        name: null,
        type: null,
    },
    position: {
        x: 0,
        y: 0,
        z: 1,
    },
    boundingBox: {
        width: 0,
        height: 0,
        top: 0,
        left: 0
    },
    dimensions: {
        width: null,
        height: null
    },
    defaultDimensions: { 
        width: 100,
        height: 100
    },
    innerDimensions: {
        width: null,
        height: null
    },
    rotateCoordinates: {
        x: 0,
        y: 0
    },
    offset: {
        x: 0,
        y: 0
    },
    flip: {
        x: 1,
        y: 1
    },
    degreesDisplayCoordinates: {
        x: -1000,
        y: -1000
    },
    dragTolerance: 5,
    isClicked: false,
    isDragging: false,
    isScaling: false,
    isRotating: false,
    isStretching: false,
    keepAspectRatio: true,
    mouseX: null,
    mouseY: null,
    startingAngle: 0,
    scaleDirection: null,
    scaleOrigin: 'TOPLEFT',
    cropType: null,
    opacity: 1,
    visible: true,
    cropable: false,
    subtype: null,
    color1: {
        branding: null,
        enabled: true,
        type: null,
        value: '#877D88',
        locked: true
    },
    color2: {
        branding: null,
        enabled: true,
        type: null,
        value: '#FFFFFF',
        locked: true
    },
    color3: {
        branding: null,
        enabled: true,
        type: null,
        value: '#545259',
        locked: true
    }
}, {
    id: null,
    pageId: null,
    selected: false,
    type: 'button',
    rotate: 0,
    textColor: {
        branding: null,
        enabled: true,
        type: null,
        value: null
    },
    buttonColor: {
        branding: null,
        enabled: true,
        type: null,
        value: null
    },
    borderColor: {
        branding: null,
        enabled: true,
        type: null,
        value: null
    },
    borderRadius: 'none',
    text: 'Example',
    fontSize: 58.3338,
    fontFamily: {
        key: 'Roboto',
        value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`
    },
    link: {
        collateralId: null,
        src: null,
        preview: null,
        name: null,
        type: null
    },
    position: {
        x: 0,
        y: 0,
        z: 1,
    },
    boundingBox: {
        width: 0,
        height: 0,
        top: 0,
        left: 0
    },
    dimensions: {
        width: null,
        height: null
    },
    innerDimensions: {
        width: null,
        height: null
    },
    rotateCoordinates: {
        x: 0,
        y: 0
    },
    offset: {
        x: 0,
        y: 0
    },
    flip: {
        x: 1,
        y: 1
    },
    degreesDisplayCoordinates: {
        x: -1000,
        y: -1000
    },
    dragTolerance: 5,
    isClicked: false,
    isDragging: false,
    isScaling: false,
    isRotating: false,
    isStretching: false,
    keepAspectRatio: true,
    mouseX: null,
    mouseY: null,
    startingAngle: 0,
    scaleDirection: null,
    scaleOrigin: 'TOPLEFT',
    cropType: null,
    opacity: 1,
    visible: true,
    cropable: false,
    subtype: null
}, {
    id: null,
    pageId: null,
    selected: false,
    type: 'pagination',
    rotate: 0,
    index: null,
    displayIndex: null,
    color: {
        branding: null,
        enabled: true,
        type: null,
        value: null
    },
    enumeration: {
        name: '1 2 3 4',
        value: 'arabicNumerals'
    },
    fontSize: 58.3338,
    fontFamily: {
        key: 'Roboto',
        value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`
    },
    position: {
        x: 0,
        y: 0,
        z: 1,
    },
    boundingBox: {
        width: 0,
        height: 0,
        top: 0,
        left: 0
    },
    dimensions: {
        width: 'auto',
        height: 'auto'
    },
    innerDimensions: {
        width: null,
        height: null
    },
    rotateCoordinates: {
        x: 0,
        y: 0
    },
    offset: {
        x: 0,
        y: 0
    },
    flip: {
        x: 1,
        y: 1
    },
    degreesDisplayCoordinates: {
        x: -1000,
        y: -1000
    },
    dragTolerance: 5,
    isClicked: false,
    isDragging: false,
    isScaling: false,
    isRotating: false,
    isStretching: false,
    keepAspectRatio: true,
    mouseX: null,
    mouseY: null,
    startingAngle: 0,
    scaleDirection: null,
    scaleOrigin: 'TOPLEFT',
    cropType: null,
    opacity: 1,
    visible: true,
    cropable: false,
    subtype: null
},  {
    id: null,
    pageId: null,
    selected: false,
    type: 'company-logo',
    name: null,
    src: null,
    imagePreview: null,
    rotate: 0,
    link: {
        collateralId: null,
        src: null,
        preview: null,
        name: null,
        type: null,
    },
    position: {
        x: -9999,
        y: 0,
        z: 1,
    },
    boundingBox: {
        width: 0,
        height: 0,
        top: 0,
        left: 0
    },
    dimensions: {
        width: null,
        height: null
    },
    innerDimensions: {
        width: null,
        height: null
    },
    rotateCoordinates: {
        x: 0,
        y: 0
    },
    offset: {
        x: 0,
        y: 0
    },
    flip: {
        x: 1,
        y: 1
    },
    degreesDisplayCoordinates: {
        x: -1000,
        y: -1000
    },
    dragTolerance: 5,
    isClicked: false,
    isDragging: false,
    isScaling: false,
    isRotating: false,
    isStretching: false,
    keepAspectRatio: true,
    mouseX: null,
    mouseY: null,
    startingAngle: 0,
    scaleDirection: null,
    scaleOrigin: 'TOPLEFT',
    cropType: null,
    opacity: 1,
    visible: true,
    cropable: true,
    subtype: null
}, {
    id: null,
    selected: false,
    type: 'table'
}, {
    id: null,
    selected: false,
    type: 'testimonial'
}, {
    id: null,
    selected: false,
    type: 'toc'
}, {
    id: null,
    selected: false,
    type: 'header'
}, {
    id: null,
    selected: false,
    type: 'footer'
},{
    id: null,
    selected: false,
    type: 'heading'
}];

export { contextElements, elements };